import React, { useEffect, useRef, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";

import { useAppDispatch } from "../../hooks/useAppDispatch";
import { useAppSelector } from "../../hooks/useAppSelector";

import {
  fetchUserById,
} from "../../store/slices/userSlice";

import Breadcrumbs from "../../components/navigation/Bredcrumbs";
import DetailTopPart from "../../components/popups/DetailTopPart";
import ClientTabs from "../../components/ClintTabs";
import plus_icon_blue from "../../assets/images/plus_icon_blue.svg";
import filter_list_icon from "../../assets/images/filter_list_icon.svg";
import SelectCommonModal from "../../components/popups/SelectCommonModal";
import user_img_1 from "../../assets/images//User.png";


const ClientDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();

  const DETAIL_KEY = `clientDetail_${id}`;

  const selectedUser = useAppSelector((s) => s.user.entityByKey[DETAIL_KEY] || null);
  const loading = useAppSelector((s) => s.user.entityLoadingByKey[DETAIL_KEY] || false);

  const COMPANY_PAGE_KEY = "clientDetailCompanies";
  const companyList = useAppSelector((s) => s.user.listDataByKey[COMPANY_PAGE_KEY] || []);

  const [showModal, setShowModal] = useState(false);
  const [activeTab, setActiveTab] = useState("companyList");
  const [companyShowModal, setCompanyShowModal] = useState(false);

  const guard = useRef(false);

  useEffect(() => {
    if (!id || guard.current) return;
    guard.current = true;

    dispatch(fetchUserById({ id, key: DETAIL_KEY }));
  }, [id, dispatch]);

  const breadcrumbItems = [
    { label: "Client List", link: "/client" },
    { label: selectedUser?.name || "Client Details", active: true },
  ];

  const BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL || "";

  const addButton = activeTab === "companyList" ? {
    text: "Add Company",
    icon: plus_icon_blue,
    showIcon: true,
    className: "btn btn_outline_primary ms-auto me-2",
    onClick: () => navigate("/addcompany", { state: { from: location.pathname, id: id } }),
  } : {
    text: "Add Employee",
    icon: plus_icon_blue,
    showIcon: true,
    className: "btn btn_outline_primary ms-auto me-2",
    onClick: () => setCompanyShowModal(true),
  };

  const buttonKey = activeTab === "companyList" ? "addCompany" : "addEmployee";

  return (
    <div className="clints_details">
      <Breadcrumbs items={breadcrumbItems} />

      <DetailTopPart
        client={{
          name: selectedUser?.name,
          email: selectedUser?.email,
          phone: selectedUser?.phone,
          address: selectedUser?.address || "N/A",
          image:
            selectedUser?.profile
              ? BASE_URL + selectedUser.profile
              : user_img_1,
        }}
        buttons={{
          [buttonKey]: addButton,
          payroll: {
            text: "Payroll",
            icon: filter_list_icon,
            className: "btn btn_primary",
            onClick: () => setShowModal(true),
          },
        }}
      />

      {showModal && (
        <SelectCommonModal
          title="Please Select Company"
          data={companyList}
          labelKey="companyName"
          valueKey="id"
          imageKey="logo"
          isMultiple
          onClose={() => setShowModal(false)}
          onApply={(companies) =>
            navigate("/selectedpayroll", {
              state: {
                clientId: id,
                companies
              },
            })
          }
        />
      )}

      <ClientTabs clientId={id} activeTab={activeTab} setActiveTab={setActiveTab} />

      {companyShowModal && (
        <SelectCommonModal
          title="Please Select Company"
          data={companyList}
          labelKey="companyName"
          valueKey="id"
          imageKey="logo"
          onClose={() => setCompanyShowModal(false)}
          onApply={(company) =>
            navigate("/addnewemployee", {
              state: { id: company.id },
            })
          }
        />
      )}
    </div>
  );
};

export default ClientDetail;
